import { AxiosResponse } from 'axios';
import { axiosInstance } from 'services';

import { IPaypalPlan } from 'types/interfaces';

export const PremiumPlans = {
    fetchPaypalPremiumPlans: (): Promise<AxiosResponse<IPaypalPlan[]>> =>
        axiosInstance.get<IPaypalPlan[]>('paypal/plan'),
    getPaypalPlan: (id: string): Promise<AxiosResponse<IPaypalPlan>> =>
        axiosInstance.get<IPaypalPlan>(`paypal/plan/${id}`),
};
